import { Component } from '@angular/core';

@Component({
  selector: 'ngx-signage-layout',
  styleUrls: ['./signage.layout.scss'],
  template: `
    <nb-layout windowMode>

      <nb-layout-column style="padding: 0px;">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

    </nb-layout>
  `,
})
export class SignageLayoutComponent { }
